module.exports = __webpack_public_path__ + "img/home button.65075c41.png";